import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {SymbolValues} from "../server/OutsourcedData";
import {OldEmitterConfig} from "pixi-particles";

/**
 * Created by jonas on 2022-06-10.
 */

export class OutsourcedStatics {
    public static SYMBOL_SPRITE_WIDTH:number = 144;
    public static SYMBOL_SPRITE_HEIGHT:number = 148;

    public static defaultSymbolValues:SymbolValues = {
        "L1": {3: 6, 4: 10, 5: 16, 6: 30, 7: 40, 8: 50, 9: 60},
        "L2": {3: 6, 4: 10, 5: 14, 6: 25, 7: 40, 8: 50, 9: 60},
        "L3": {3: 5, 4: 8, 5: 12, 6: 25, 7: 30, 8: 40, 9: 50},
        "L4": {3: 5, 4: 8, 5: 12, 6: 20, 7: 30, 8: 40, 9: 50},
        "L5": {3: 5, 4: 8, 5: 12, 6: 20, 7: 30, 8: 40, 9: 50},
        "M1": {3: 20, 4: 30, 5: 40, 6: 50, 7: 60, 8: 70, 9: 80},
        "M2": {3: 15, 4: 20, 5: 30, 6: 40, 7: 50, 8: 60, 9: 70},
        "M3": {3: 12, 4: 20, 5: 30, 6: 40, 7: 50, 8: 60, 9: 70},
        "M4": {3: 12, 4: 15, 5: 20, 6: 35, 7: 45, 8: 55, 9: 65},
        "M5": { 3: 10, 4: 15, 5: 20, 6: 35, 7: 45, 8: 55, 9: 65},
    };

    constructor() {
    }


}